import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { ciphMessageExporterEnvironment } from '../cpih-message-exporter-environment';
import { CpihMessage } from '../schemas/cpih-message.schema';

/**
 * Sends a message to provided drivers
 * @param consumer The consumer application
 * @param partner The partner Id
 * @param messages The messages to send wth their recipients
 */
export function postMessageConsumerPartner(
  this: unknown,
  consumer: string,
  partner: string,
  messages: CpihMessage[]
) {
  return fromFetch(
    new Request(
      ciphMessageExporterEnvironment
        .resolve(this)
        .messageConsumerPartnerUrl(consumer, partner),
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(messages),
      }
    )
  ).pipe(ignoreData());
}
